import PageContainer from '@/common/components/PageContainer'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import {
	useQueryStates,
	parseAsString,
	parseAsBoolean,
	parseAsInteger,
} from 'nuqs'
import useQueryGetShopItems from '@/modules/shop/api/hooks/useQueryGetShopItems'
import ShopItemsListing from '@/modules/shop/components/ShopItemsListing'
import { CurrencyType, ShopItemType } from '@/schema'
import { useDebounceValue } from 'usehooks-ts'

function ShopItemsPage() {
	const [queryParams] = useQueryStates({
		page: parseAsInteger.withOptions({ shallow: false }).withDefault(1),
		limit: parseAsInteger.withOptions({ shallow: false }).withDefault(10),
		q: parseAsString
			.withOptions({ shallow: false, throttleMs: 500 })
			.withDefault(''),
		currencyType: parseAsString.withOptions({ shallow: false }).withDefault(''),
		rewardType: parseAsString.withOptions({ shallow: false }).withDefault(''),
		isActive: parseAsBoolean.withOptions({ shallow: false }),
	})

	const [debouncedQuery] = useDebounceValue(queryParams.q, 500)

	const query = {
		take: queryParams.limit,
		skip: (queryParams.page - 1) * queryParams.limit,
		name: debouncedQuery || undefined,
		currencyType: (queryParams.currencyType as CurrencyType) || undefined,
		rewardType: (queryParams.rewardType as ShopItemType) || undefined,
		isActive: queryParams.isActive ?? undefined,
	}

	const { data, isLoading } = useQueryGetShopItems(query)

	return (
		<PageContainer>
			<ShopItemsListing
				data={data?.data || []}
				total={data?.total || 0}
				isLoading={isLoading}
			/>
		</PageContainer>
	)
}

export default withUserPermission(ShopItemsPage, {
	permissionType: PermissionType.Read,
	permissionKey: [PermissionKeys.MANAGE_SHOP],
})
